import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const LabelPurchasedAtCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Label purchased at",
    cell: (row) => {
      return formatDateString(row.shipment?.boughtRate?.created_at ?? "");
    },
  };
